import type {z} from 'zod';
import type {walletNetwork} from '../src/commerce-crypto/wallet-contract';
import {dateTime,ErrorNotice} from './components';

export function PaymentNetworkStatus({networks}:{networks:Omit<z.infer<typeof walletNetwork>,'mode'>[]}){
  return <>{networks.filter(network=>!network.available).map(network=><div key={network.assetId}>
    <ErrorNotice title={`${network.asset} · ${network.label}`} error={{name:'PaymentNetworkUnavailable',message:network.reason!,...(network.error===null?{}:{cause:network.error})}}/>
    {network.observedAt&&<p>Last scan: {dateTime(network.observedAt)}</p>}
  </div>)}</>;
}
